import { render, staticRenderFns } from "./PanoramaPalette.vue?vue&type=template&id=236428be"
import script from "./PanoramaPalette.vue?vue&type=script&lang=js"
export * from "./PanoramaPalette.vue?vue&type=script&lang=js"
import style0 from "./PanoramaPalette.vue?vue&type=style&index=0&id=236428be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports